<template>
  <modal-notification :active="active" title="Panier" @closed="$emit('closed')">
    <p class="mb-2">Attention {{ text }}:</p>
    <ul class="mb-6">
      <li class="my-1" v-for="(cart, index) in carts" :key="index">
        <strong>{{ cart.customer }}</strong>
        contenant {{ cart.products_count }} {{ cart.products_count > 1 ? 'produits' : 'produit' }}
        <em class="text-sm">({{ expireIn(cart.expired_at) }})</em>
      </li>
    </ul>
    <vue-alert type="warning" icon="broadcast-solid">
       Un panier expiré ne peut plus être commandé et sera automatiquement supprimé à la fin de la journée.
    </vue-alert>
    <vue-button slot="actions" class="btn btn-primary w-full md:w-auto mb-2 md:mb-0" @click="handleClick">Voir les paniers</vue-button>
  </modal-notification>
</template>

<script>
/* globals moment route */

import modal from '../../mixins/modal';
import ModalNotification from './NotificationModal.vue';

export default {
  mixins: [modal],

  components: { ModalNotification },

  computed: {
    carts() {
      return this.data.data.carts;
    },

    text() {
      return this.carts.length > 1
        ? 'des paniers vont bientôt expirer'
        : 'un panier va bientôt expirer';
    },
  },

  methods: {
    expireIn(time) {
      if (moment(time).isBefore()) {
        return 'expiré';
      }
      return `expire ${moment(time).fromNow()}`;
    },

    handleClick() {
      window.location.href = route('carts.index');
    },
  },
};
</script>